<template>
  <div>
    <div class="edit-wrapper__top">
      <h2 class="edit-wrapper__title">
        <slot name="title">
          {{ title }}
        </slot>
      </h2>
      <template v-if="!disabled">
        <oie-base-action
          v-if="!editMode"
          theme="flat"
          :aria-label="`${tStatic('edit')} ${title}`"
          @click="toggle()">
          <template #iconPrepend>
            <oie-base-icon icon="edit" size="xs"></oie-base-icon>
          </template>
          {{ tStatic('edit') }}
        </oie-base-action>
        <slot v-else name="edit-actions" :toggle="toggle"></slot>
      </template>
    </div>
    <slot v-if="editMode" name="edit-content" :toggle="toggle"></slot>
    <slot v-else name="preview-content"></slot>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editMode: false
    }
  },
  methods: {
    toggle(value) {
      value ? this.editMode = value : this.editMode = !this.editMode
    }
  }
}
</script>

<style lang="scss">
.edit-wrapper__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: measure(half);
}

.edit-wrapper__title {
  @include h3-semi-bold;
  margin: 0;
}

</style>
